import { IStore } from '@/store/types';
import { IModuleState } from './types';
import * as actions from './actions';
import * as mutations from './mutations';

const initialState = {
  list: { data: [], total: 0, pageNum: 0, pageSize: 0, loading: false },
  dataBrands: { data: [], total: 0, pageNum: 0, pageSize: 0, loading: false },
  allSubBrands: { data: [], total: 0, pageNum: 0, pageSize: 0, loading: false },
  subBrands: { data: [], total: 0, pageNum: 0, pageSize: 0, loading: false },
  allAuthOrgs: { data: [], total: 0, pageNum: 0, pageSize: 0, loading: false },
  authedOrgs: { data: [], total: 0, pageNum: 0, pageSize: 0, loading: false },
  detail: { data: null, loading: false },
  dialog: { visible: false, loading: false },
  confirm: { title: '', content: '', visible: false, loading: false },
  searchParams: null,
  loading: false,
};

export default { namespaced: true, state: initialState, actions, mutations } as IStore<IModuleState>;
